export class IOsaExecucaoPapelTrabalho {
  id?: number;
  osaExecucaoId?: number;
  idPapel?: number;
  idTipoAceitavel?: number;
  arquivos?: IOsaExecucaoPapelTrabalhoArquivo[];
  justificativa?: string;
  link?: string;
  posicao?: number;
  nomePapelManual?: string;

  //Propriedades de Tela
  nomePapel?: string;
  situacaoNome?: string;
  controle?: number; //usado para por o name e id no campo input file
  removidos?: IOsaExecucaoPapelTrabalhoArquivo[];
  sigla?: string;
  valido?: boolean; //Usado para validar no Envio para Aprovação
  addManual?: boolean; //Usado para controlar se o papel foi add direto na tela
}

export class IOsaExecucaoPapelTrabalhoArquivo {
  id: number;
  arquivoId?: number;
  osaExecucaoPapelTrabalhoId: number;
  nome: string;
  tipo: string;
  arquivo: string;

  //Propriedade de tela
  controle?: number;
}
